// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-6b3ac0","sapcnqr-badge--muted":"sapcnqr-badge--muted-29295b"};